import { defineCustomElement } from "vue";
import VueCartIntegration from "@/vue/CartIntegration.vue";

export const CartIntegration = defineCustomElement(VueCartIntegration);

customElements.define("lora-cart-integration", CartIntegration);
